// Types
export type { SplitDetailPanelContextValue } from './context';
export type { ReconcileStrategy, UseReconcileTabsOptions, UseReconcileTabsReturn } from './hooks';
// Phase 5: usePanelActions 타입 추가
export type { TabPanelOptions, UsePanelActionsReturn } from './hooks/usePanelActions';
export type { ListPanelProviderProps } from './provider';
export type { SplitListPanelContextValue } from './provider/SplitListPanelProvider';
export type {
  ResourceItem,
  PanelComponentProps,
  PanelComponent,
  TabKey,
  TabItem,
  ListPanelCoreState,
  ListPanelDerivedState,
  ListPanelPreferenceState,
  ListPanelLayoutGuardState,
  ListPanelActions,
  ListPanelStore,
  SplitDetailPanelState,
  SplitDetailPanelActions,
  SplitDetailPanelStore,
} from './types';

// Context
export { SplitListPanelStoreContext, SplitDetailPanelStoreContext } from './context';
// Hooks (for Context-based stores)
export {
  // SplitListPanel hooks
  useSplitListPanelContext,
  useSplitListPanelSelector,
  useSplitListPanelActions,
  useSplitListPanelDerivedState,
  useSplitListPanelPreferences,
  useSplitListPanelLayoutGuard,
  useSplitListPanelSelectedIds,
  useSplitListPanelFocusedId,
  // SplitDetailPanel hooks
  useSplitDetailPanelContext,
  useSplitDetailPanelSelector,
  // Phase 6: 새 이름
  useTabPanelActionStoreInternal,
  // Phase 6: 레거시 별칭 (deprecated)
  useSplitDetailPanelActions,
  useSplitDetailPanelTabs,
  useSplitDetailPanelActiveTabKey,
  useSplitDetailPanelActiveTab,
  useSplitDetailPanelVisible,
  useSplitDetailPanelTabCount,
  useSplitDetailPanelMaxTabs,
  useSplitDetailPanelCanAddTab,
  useSplitDetailPanelDerivedState,
  // Tab reconciliation hooks
  useReconcileTabs,
  useTabAccessTracker,
} from './hooks';
// Phase 5: usePanelActions (Public API)
export { usePanelActions } from './hooks/usePanelActions';
// Utilities
export { setEquals, shallowEqual, arrayEquals } from './lib/equality';
// Providers (Context-based store instances)
export {
  DetailPanelProvider,
  ListPanelProvider,
  SplitListPanelProvider,
  SplitDetailPanelProvider,
} from './provider';
// Global Stores (singleton instances)
export { useListPanelStore, createSplitDetailPanelStore, createTabKey, parseTabKey } from './store';
// Constants
export { MAX_TABS, DEFAULT_LIST_PANEL_PREFERENCE, DEFAULT_LIST_PANEL_LAYOUT_GUARD } from './types';
// UI Components
export { PanelTabBar, SplitPanelPortal } from './ui';
